<template>
  <label class="radio">
    <input
      class="radio__input"
      type="radio"
      :name="name"
      :value="value"
      :checked="value === model"
      :disabled="isDisabled"
      v-bind="$attrs"
      v-on="$listeners"
      v-data-test-id="'input'"
      @change="onChange"
    />
    <span v-if="!hasRadioButtonHidden" class="radio__circle custom-radio-input"></span>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'Radio',

  // bind attributes to input (not to rool el) using v-bind="$attrs"
  inheritAttrs: false,

  props: {
    name: {
      type: String,
    },
    value: {
      type: String,
    },
    model: {
      type: String,
    },
    hasRadioButtonHidden: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChange($event) {
      this.$emit('update:model', $event.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/components/_shared/Form/form-settings';

.radio {
  &:hover &__circle:before {
    border-color: $field-border-color-focused !important;
  }

  &__circle {
    cursor: pointer;

    &:before {
      transition: border-color $transition-time-fast;
      border-color: $field-border-color !important;
    }
  }
}
</style>
